import React from 'react';
import { formatRoundedRupeeLiteral } from '../../utils/commonUtils';

interface AmcBlurbProps {
  amcData: {
    amcAum: number;
    amcSchemes: number;
  } | null;
}

const AmcBlurb: React.FC<AmcBlurbProps> = ({ amcData }) => {
  if (!amcData) {
    return <div>Data Loading</div>;
  }

  const { amcAum, amcSchemes } = amcData;

  return (
    <div className="lil-flex lil-p-3 lil-rounded-lg lil-bg-blue-50">
      <div className="lil-pr-8 lil-pl-12 sm:lil-w-1/2 sm:lil-pl-3 sm:lil-pr-0">
        <p>AUM</p>
        <p className="lil-text-black lil-font-bold lil-whitespace-no-wrap">
          ₹{formatRoundedRupeeLiteral(amcAum)}
        </p>
      </div>
      <div className="lil-border-r-sm lil-border-grey-300"></div>
      <div className="lil-px-8 sm:lil-w-1/2 sm:lil-pl-6 sm:lil-pr-0">
        <p className="lil-whitespace-no-wrap">No. of schemes</p>
        <p className="lil-text-black lil-font-bold">{amcSchemes}</p>
      </div>
    </div>
  );
};

export default AmcBlurb;



// WEBPACK FOOTER //
// ./components/amcNew/AmcBlurb.tsx